import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-sand flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="font-heading text-9xl text-terracotta/20">404</h1>
        <h2 className="font-heading text-3xl text-forest -mt-8 mb-4">
          Strona nie istnieje
        </h2>
        <p className="font-body text-forest/70 mb-8 max-w-md mx-auto">
          Przepraszamy, strona której szukasz nie została znaleziona. 
          Może chcesz wrócić na stronę główną?
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/">
            <Button className="bg-forest hover:bg-forest-light text-white gap-2">
              <Home className="w-4 h-4" /> Strona główna
            </Button>
          </Link>
          <Button 
            variant="outline" 
            onClick={() => window.history.back()}
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" /> Wróć
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
